import React, { useState,useEffect } from 'react'
import {MDBRow, MDBCol, MDBInput, MDBBtn, MDBBtnGroup ,MDBIcon, MDBContainer} from 'mdbreact';
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from 'axios';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import WarningBox from '../components/WarningBox';


import { toast, ToastContainer} from "mdbreact";



const AddEditBundle=(props)=>{

  const useMountEffect = (functionName) => useEffect(functionName, [])

  

       
  const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }
  const [frm, setValues] = useState({
       code:'',
       description:'',
       kilograms:1,
       quantityperbundle:1,
       kilosperbundle:1,
       usertoken: sessionStorage.getItem("msal.uc")
   
  });
  
  
      
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const updateField = e => {
       
    const target=e.target;
   
    let  value =target.value;
    let name=target.id;
  
    if(target.type==="checkbox")
    {
      value=target.checked;
      
      setValues({ ...frm, [name]: value });
    }
    else
    {
       
     
            setValues({ ...frm, [name]: value });
      
    }

   

};

      
function cascadeTotalKilos()
{
   

    var x=frm.quantityperbundle * frm.kilograms;
    setValues({ ...frm, kilosperbundle: x });
}
   
  function submitHandler (event){
        event.preventDefault();
        event.target.className += " was-validated";
        
         savebundle();

  }
    

  const [errorMessage,setErrorMessage]=useState("");

  const [modalWarning,showWarningBox]=useState(false);
  
  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  
    }


   

  const loadbundledetails=()=>
  {
    
    Axios.get(props.apiServer + '/loadbundledetails?acode=' + props.code ,bearer)
      .then(res => 
      {
        if(res.data!=="empty")
        {
         
            setValues({ ...frm,
        
                code:props.code,
                description:res.data.description ,
                kilograms:res.data.kilograms ,
                quantityperbundle:res.data.quantityperbundle ,
                kilosperbundle:res.data.kilosperbundle ,
                usertoken: sessionStorage.getItem("msal.uc")
            });   
                  
                  
        }
        else
        {
       
            console.log('No record');
        
        }
           
    
      })
      
      .catch(error => {
        setErrorMessage(error);
        toggleWarningBox();
          
      });  
    
         
  }


  const savebundle=()=> {
    
     const data =frm;
   

     if((frm.kilograms* frm.quantityperbundle != frm.kilosperbundle))
     {
        setErrorMessage("Total kilos per bundle should be equal to the product quantity per bundle and kilogram per unit !");
        toggleWarningBox();
        return;
     }
     Axios.post(props.apiServer + "/savebundle", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
            setValues({...frm, code : res.data.code});
          props.refreshGrid();
             toast.info(res.data.message, {
                closeButton: false
                
              });
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });
   
 }



 
 const deletebundle=()=>
 {
    const data =frm;

   
     Axios.post(props.apiServer + "/deletebundle", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
        props.refreshGrid();
          
             toast.info(res.data.message, {
                closeButton: false
                
              });
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });

  
   
        
 }


 const [isAdmin,checkAdmin]=useState(0);

      
 function checkAdminAccess() {
     
 
   Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
    .then(res => {
    
       checkAdmin(0);
       checkAdmin(res.data[0].isadmin);
   
    })
  
    .catch(error => {
     
     console.log(error);
    });  
   
  
  
  
  }

useMountEffect(loadbundledetails);



    return (
        <React.Fragment>
        
           <MDBContainer fluid >

           
            <MDBRow>
                <MDBCol >
              
                    <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
                     
                 
                   
                  

    
                    <MDBRow hidden>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.code} 
                            id="code"  
                            label="code" 
                            required
                            
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

         
                    <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.description} 
                            id="description"  
                            label="description" 
                            required
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

           
                    <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.kilograms} 
                            id="kilograms"  
                            label="Kilogram (Per unit)" 
                            required
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>


                  

                    <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.quantityperbundle} 
                            id="quantityperbundle"  
                            label="Number of Plastics Per Bundle" 
                            required
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

                    <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.kilosperbundle} 
                            id="kilosperbundle"  
                            label="Total Kilos per Bundle" 
                            required
                            
                            
                            >
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>


                   <MDBRow>
                       <MDBCol md="6">
                       <MDBBtn className="blue lighten-1" type="submit">
                        Save
                    </MDBBtn>  {props.code==="" ?
                           (<MDBBtn id="cmdClose" className="blue lighten-4 blue-text"  onClick={props.toggleModal}>
                           Close
                       </MDBBtn>):(  
                       <MDBBtn color="danger" onClick={deletebundle}>
                       Delete
                   </MDBBtn>
                      
                       
                    
                    )}
                       </MDBCol>
                       <MDBCol md="6">
                     
                       
                       </MDBCol>
                   </MDBRow>

                   
                  
                    </form>
                  
                </MDBCol>
            </MDBRow>
            </MDBContainer>
            <ToastContainer
            hideProgressBar={true}
            newestOnTop={true}
            autoClose={5000}/>

        
            <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>
            {/* <MessagePersonalInfo /> */}
        </React.Fragment>
    );

}
export default AddEditBundle
